import React from 'react';

const FormError = props => {
  const getMessage = err => {
    if (err.message) return err.message;
    if (err.type == 'required') {
      return 'This field is required';
    } else if (err.type == 'maxLength') {
      return 'Maximum length exceeded';
    } else if (err.type == 'minLength') {
      return 'Minimum length not fulfilled';
    } else {
      return 'This field is required';
    }
  };
  return (
    <>
      <div
        style={{ color: '#F44336', marginTop: '10px', fontSize: '14px' }}
        className="sub-heading2 f-400"
      >
        {getMessage(props.msg)}
      </div>
    </>
  );
};

export default FormError;
